export const premioMalintzinRecipients = [
  { name: 'Martha Flisser', year: '1994' },
  { name: 'Italia Morayta', year: '1996', note: 'qepd' },
  { name: 'Nina Marentes', year: '1998' },
  { name: 'Laura Zocchi', year: '2000', note: 'qepd' },
  { name: 'Guido Gómez de Silva', year: '2002', note: 'qepd' },
  { name: 'Georganne Weller', year: '2004' },
  { name: 'Héctor Acosta', year: '2004', note: 'in memoriam' },
  { name: 'Georgina Marín', year: '2006', note: 'qepd' },
  { name: 'Barbara Baer de Gómez', year: '2006', note: 'in memoriam' },
  { name: 'Sergio Alarcón', year: '2008' },
  { name: 'Edda Webels', year: '2010' },
  { name: 'Laura Soto Reyes de Castro', year: '2012' },
  { name: 'Carmen Bancalari', year: '2014' },
  { name: 'Gabriela Durazo', year: '2016' },
  { name: 'Patricia Yáñez', year: '2018' },
  { name: 'Josefina MacGregor', year: '2020' },
];

export const pastPresidents = [
  { name: 'Sergio Alarcón', period: '1982-1984' },
  { name: 'Edda Webels', period: '1984-1988' },
  { name: 'Ana María Sotelo', period: '1988-1990' },
  { name: 'Martha Flisser', period: '1990-1992' },
  { name: 'Guido Gómez de Silva', period: '1992-1993' },
  { name: 'Patricia Yáñez', period: '1993-1995' },
  { name: 'Nina Marentes', period: '1995-1997' },
  { name: 'Alicia Coquet', period: '1997-1998' },
  { name: 'Lucila Christen', period: '1998-2000' },
  { name: 'Francisco Javier López', period: '2000-2001' },
  { name: 'Irma Blanco', period: '2001-2002' },
  { name: 'Patricia Yáñez', period: '2002-2003' },
  { name: 'Sergio Alarcón', period: '2003-2004' },
  { name: 'Laura Soto Reyes de Castro', period: '2004-2006' },
  { name: 'María Dolores Madinaveitia de Lebrun', period: '2006-2008' },
  { name: 'Carlos Crowley', period: '2008-2009' },
  { name: 'Luz Amelia McClellan', period: '2009-2010' },
  { name: 'Elsa Muñoz', period: '2010-2012' },
  { name: 'Hilda Tejada', period: '2012-2016' },
  { name: 'Gabriela Murga', period: '2016-2017' },
  { name: 'Edna Cerf', period: '2017-2018' },
  { name: 'Mónica Ibarra', period: '2018-2020' },
  { name: 'Verónica Méndez', period: '2020-2021' },
  { name: 'Consejo de Expresidentes', period: '2021-2022' },
  { name: 'Ernesto Zavala', period: '2022-2025' },
  { name: 'Lorenia Rincón', period: '2025-a la fecha' },
];

export const expresidentesClosingText = {
  es: 'En la actualidad, el Colegio Mexicano de Intérpretes de Conferencias continúa trabajando para fortalecer la profesión en México, promoviendo altos estándares de calidad, ética y formación profesional. El Colegio busca crecer, mantenerse relevante ante los cambios tecnológicos y las nuevas dinámicas del mercado, y seguir siendo un referente e inspiración para las nuevas generaciones de intérpretes. Al mismo tiempo, mantiene su compromiso histórico de cuidar, apoyar y dignificar a quienes ejercen esta profesión, fomentando la colaboración entre colegas y el reconocimiento del valor del trabajo de interpretación profesional.',
  en: 'Today, the Mexican College of Conference Interpreters continues to work to strengthen the profession in Mexico, promoting high standards of quality, ethics, and professional training. The College seeks to grow, remain relevant in the face of technological changes and new market dynamics, and continue to be a reference and inspiration for new generations of interpreters. At the same time, it maintains its historical commitment to caring for, supporting, and dignifying those who practice this profession, fostering collaboration among colleagues and recognition of the value of professional interpretation work.',
};
